import type { ReactNode } from 'react'

import { MarkdownContent } from '@/components/atoms/markdown-content.atom'
import { Separator } from '@/components/ui/separator'

interface AgencyDetailDescriptionSectionProps {
  title: string
  content: string
  isMarkdown?: boolean
}

export const AgencyDetailDescriptionSection = ({
  title,
  content,
  isMarkdown = false,
}: AgencyDetailDescriptionSectionProps): ReactNode => (
  <>
    <Separator />
    <div className="agency-detail-section space-y-2">
      <h3 className="text-sm font-semibold text-foreground">{title}</h3>
      {isMarkdown ? (
        <MarkdownContent content={content} size="sm" className="text-muted-foreground" />
      ) : (
        <p className="text-sm text-muted-foreground whitespace-pre-line">{content}</p>
      )}
    </div>
  </>
)

AgencyDetailDescriptionSection.displayName = 'AgencyDetailDescriptionSection'
